import * as React from 'react';
import { useSelector } from 'react-redux';
import ValidationWarning from '../validationWarning/ValidationWarning';
import { RootState } from '../../store/rootReducer';

const WarningBar = () => {
    const { context, warning } = useSelector((state: RootState) => state);
    return (warning.hasMaximaValidationIssue && context.workspaceId === 'evaluate_review_candidates') ? (
        <ValidationWarning partyId={warning.partyId} questionId={warning.questionId} />
    ) : null;
};

export default WarningBar;
